export default {
  capitalise (str) {
    return str[0].toUpperCase() + str.substring(1)
  },
  snakeToSpace (str) {
    return str.replace(/_/g, ' ', true)
  },
}
